const common = {
  MAX_NODE_LENGTH: 5,
  DEFAULT_TEMPLATE_EXPIRED_DAY: 7,
  DEFAULT_TRIP_RANGE: 14,
  UPLOAD_IMAGE_FILE_SIZE_LIMIT_BYTES: 5000000,
  UPLOAD_AUDIO_FILE_SIZE_LIMIT_BYTES: 20000000,
  UPLOAD_VIDEO_FILE_SIZE_LIMIT_BYTES: 20000000,
  MAX_CARD_TITLE_LENGTH: 40,
  MAX_CARD_SUBTITLE_LENGTH: 60,
  MAX_BUTTON_TITLE_LENGTH: 20,
  MAX_END_COUNT: 15,
  MAX_FLOW_COUNT: 20,
  DEBOUNCE_DELAY: 600,
  SESSION_TOKEN_NAME: 'ma_parseSessionToken',
  ORGID_NAME: 'ma_organization',
  PARSE_JAVASCRIPT_KEY: 'javascriptKey',
  APP_TITLE: 'SUPER 8 Studio',
};

const dev = {
  URL: 'https://stage-marketing-automation.no8.io/',
  PARSE_SERVER_URL: 'https://stage-api-live-query.no8.io',
  PARSE_APP_ID: 'number8_stage',
  MA_SERVER_URL: 'https://stage-api-next.no8.io',
  META_TAG_CRAWLER_URL: 'https://t.no8.io/crawl',
  UPLOAD_URL: 'https://t.no8.io/uploader/files',
  CONSOLE_URL: 'https://stage-console.no8.io',
};

const prod = {
  URL: 'https://marketing-automation.no8.io/',
  PARSE_SERVER_URL: 'https://prod-api-lq.no8.io',
  PARSE_APP_ID: 'number8',
  MA_SERVER_URL: 'https://api-next.no8.io',
  META_TAG_CRAWLER_URL: 'https://n.no8.io/crawl',
  UPLOAD_URL: 'https://n.no8.io/uploader/files',
  CONSOLE_URL: 'https://console.no8.io',
};

const config =
  process.env.REACT_APP_STAGE === 'production'
    ? { ...common, ...prod }
    : { ...common, ...dev };

export default config;
